import React from "react";
import "./GlobalAiToast.css";

function fmtTime(ms) {
  try { return new Date(ms).toLocaleString(); } catch { return ""; }
}

export default function GlobalAiInboxDrawer({
  open, onClose,
  soundOn, setSoundOn,
  inbox,
  onOpenItem,
  onMarkAllRead,
}) {
  React.useEffect(() => {
    function onKey(e) { if (e.key === "Escape") onClose?.(); }
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="gai-inbox-overlay" onMouseDown={onClose}>
      <div className="gai-inbox-panel" onMouseDown={(e) => e.stopPropagation()}>
        <div className="gai-inbox-head">
          <div className="gai-inbox-title">AI Notifications</div>
          <div className="gai-inbox-actions">
            <button className="gai-btn" onClick={() => setSoundOn(v => !v)}>
              {soundOn ? "🔔 Sound ON" : "🔕 Sound OFF"}
            </button>
            <button className="gai-btn" onClick={onMarkAllRead}>Mark all read</button>
            <button className="gai-x" onClick={onClose} aria-label="Close">×</button>
          </div>
        </div>

        <div className="gai-inbox-list">
          {(inbox || []).length === 0 ? (
            <div className="gai-inbox-empty">No notifications yet.</div>
          ) : (
            inbox.map((n) => (
              <button
                key={n.id}
                className={`gai-inbox-item ${n.read ? "read" : "unread"}`}
                onClick={() => onOpenItem(n)}
              >
                <div className="gai-inbox-row">
                  <div className="gai-inbox-left">
                    <div className="gai-inbox-symbol">
                      {n.symbol ? n.symbol.replace(/USDT$/i, "") : "—"}
                    </div>
                    <div className="gai-inbox-time">{fmtTime(n.createdAt)}</div>
                  </div>
                  {!n.read && <div className="gai-dot" />}
                </div>
                <div className="gai-inbox-title2">{n.title}</div>
                <div className="gai-inbox-msg">{n.message}</div>
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
